import React from "react";

const EngagementManager = ({
  width = 64,
  height = 64,
  viewBox = "-2 -5 34 34",
  color = "#FFF",
  ...rest
}) => {
  return (
    <svg
      x="0px"
      y="0px"
      viewBox={viewBox}
      height={height}
      width={width}
      {...rest}
    >
      <g>
        <path
          fill="none"
          stroke={color}
          strokeWidth="3"
          d="M3,0h24c1.7,0,3,1.3,3,3v12c0,1.7-1.3,3-3,3H3c-1.7,0-3-1.3-3-3V3C0,1.3,1.3,0,3,0z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill={color}
          d="M10,19h10v4c0,0.6-0.4,1-1,1h-8c-0.6,0-1-0.4-1-1V19L10,19z"
        />
        <line
          fill="none"
          stroke={color}
          strokeLinecap="round"
          x1="10.5"
          y1="5.5"
          x2="19.5"
          y2="5.5"
        />
        <line
          fill="none"
          stroke={color}
          strokeLinecap="round"
          x1="10.5"
          y1="8.5"
          x2="19.5"
          y2="8.5"
        />
        <line
          fill="none"
          stroke={color}
          strokeLinecap="round"
          x1="10.5"
          y1="11.5"
          x2="19.5"
          y2="11.5"
        />
      </g>
    </svg>
  );
};

export default EngagementManager;
